import { Mission } from '@/types/mission';
import { api } from './api';
import { ReservationStatus } from '@/types/reservation';
import { DateTime } from 'luxon';

const BASE_URL = '/cms/missions';

const RESERVATION_BASE_URL = '/cms/reservation';

export async function getMissionById(id: string): Promise<Mission> {
  const response = await api.get<Mission>(`${BASE_URL}/${id}`, {
    params: { 'File.category': 'MISSION_DOCUMENT' },
  });
  return response.data;
}

export async function requestMarkPatientAsNoShow(reservationId: number): Promise<void> {
  const response = await api.put(`${RESERVATION_BASE_URL}/${reservationId}`, {
    status: ReservationStatus.NO_SHOW,
  });

  return response.data;
}

export async function requestMarkAsCompleted(reservationId: number): Promise<void> {
  const response = await api.put(`${RESERVATION_BASE_URL}/${reservationId}`, {
    status: ReservationStatus.COMPLETED,
    completed_at: DateTime.now(),
  });

  return response.data;
}
